module.exports = __webpack_public_path__ + "img/lr-cb66-011.14d3fe76.gif";